import React from "react";
import "./styles.css";
import HeaderImage from "./assets/images/header-photo.jpg";
import { ReactComponent as CheckIcon } from "../../../assets/icons/check.svg";
import { Slider } from "../../HousingComplex/components/Slider";
import { villaImages, villaPlans } from "./assets/images";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { VillaDescription } from "./VillaDescription";
import { villaDescriptions } from "./villaDescriptions.js";
import { ScrollAwareBlock } from "../../../components/common/ScrollAwareBlock";
import { TelegramForm } from "./TelegramRequest";
import { Helmet } from "react-helmet";
import {
  ANALYTICS_EVENTS,
  trackAnalyticsEvent,
} from "../../../analytics";

export const RamadanVillage = ({}) => {
  const isMobile = useIsMobile();
  return (
    <>
      <Helmet>
        <title>
          Коттеджный посёлок "Рамадан" — виллы в Чечне от застройщика из ОАЭ
        </title>
        <meta
          name="description"
          content="Впервые в Чеченской Республике! Роскошные виллы в коттеджном посёлке 'Рамадан' от застройщика из ОАЭ. Рассрочка до 4 лет. Свой сад, мечеть, охраняемая территория."
        />
        <meta
          name="keywords"
          content="коттеджный посёлок, виллы Чечня, купить виллу, новостройки, рассрочка на дом, дом с участком, Рамадан, виллы из ОАЭ"
        />
      </Helmet>
      <div className="ramadan_container">
        <div
          className="ramadan_header"
          style={{ backgroundImage: `url(${HeaderImage})` }}
        >
          <ScrollAwareBlock className="ramadan_header-scroll" position="top">
            <div className="ramadan_header-title">ПОСЁЛОК "РАМАДАН"</div>
            <div className="ramadan_header_phones">
              <a
                href="tel:+79626294078"
                className="ramadan_phone"
                onClick={() =>
                  trackAnalyticsEvent(
                    ANALYTICS_EVENTS.LANDING_PHONE_CLICKED,
                    {
                      landing_id: "ramadan_village",
                      contact_role: "sales_agent",
                    },
                  )
                }
              >
                +7 (962) 629-40-78 Анита
              </a>
            </div>
          </ScrollAwareBlock>
        </div>
        <div className="ramadan_content">
        <div className="ramadan_description">
            <div className="ramadan_description-title">
              Впервые в Чеченской Республике!
            </div>
            На рынок недвижимости выходит застройщик из ОАЭ с эксклюзивным
            коттеджным посёлком в стиле современного Дубая. Закрытая, охраняемая
            территория с первоклассной инфраструктурой:
            <ul className="ramadan_list">
              <li className="ramadan_list-item">
                {isMobile && (
                  <CheckIcon fill="#c06198" width="20px" height="20px" />
                )}
                Изящная мечеть
              </li>
              <li className="ramadan_list-item">
                {isMobile && (
                  <CheckIcon fill="#c06198" width="20px" height="20px" />
                )}
                Зеленый парк для отдыха
              </li>
              <li className="ramadan_list-item">
                {isMobile && (
                  <CheckIcon fill="#c06198" width="20px" height="20px" />
                )}
                Спортивные и детские площадки
              </li>
              <li className="ramadan_list-item">
                {isMobile && (
                  <CheckIcon fill="#c06198" width="20px" height="20px" />
                )}
                Торговые центры и уютный садик
              </li>
              <li className="ramadan_list-item">
                {isMobile && (
                  <CheckIcon fill="#c06198" width="20px" height="20px" />
                )}
                Простор и комфорт в каждой детали
              </li>
            </ul>
            <div
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: 0,
                overflow: "hidden",
                margin: "20px 0",
              }}
            >
              <iframe
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
                src="https://rutube.ru/play/embed/96f8862e1d7a242683357ef3c3681b14"
                frameBorder="0"
                allow="clipboard-write; autoplay"
                webkitAllowFullScreen
                mozallowfullscreen
                allowFullScreen
              ></iframe>
            </div>
            К вашему вниманию — роскошные 2-этажные виллы площадью до 200 м²,
            дополнительно:
            <ul className="ramadan_list">
              <li className="ramadan_list-item">
                {isMobile && (
                  <CheckIcon fill="#c06198" width="20px" height="20px" />
                )}{" "}
                Просторный навес 50 м²
              </li>
              <li className="ramadan_list-item">
                {isMobile && (
                  <CheckIcon fill="#c06198" width="20px" height="20px" />
                )}
                Собственный сад и двор
              </li>
              <li className="ramadan_list-item">
                {isMobile && (
                  <CheckIcon fill="#c06198" width="20px" height="20px" />
                )}{" "}
                Участок 8 соток с полным благоустройством
              </li>
            </ul>
          </div>
        </div>
        <div className="ramadan_villas-container">
          <div className="ramadan_villa-container">
            <div className="ramadan_description-title">Вилла №1</div>
            <Slider images={villaImages.villa1} />
            <div className="ramadan_description-title-secondary">
              Планировки
            </div>
            <Slider images={villaPlans.villa1} />
            <VillaDescription items={villaDescriptions.villa1} />
          </div>

          <div className="ramadan_villa-container">
            <div className="ramadan_description-title">Вилла №2</div>
            <Slider images={villaImages.villa2} />
            <div className="ramadan_description-title-secondary">
              Планировки
            </div>
            <Slider images={villaPlans.villa2} />
            <VillaDescription items={villaDescriptions.villa2} />
          </div>

          <div className="ramadan_villa-container">
            <div className="ramadan_description-title">Вилла №3</div>
            <Slider images={villaImages.villa3} />
            <div className="ramadan_description-title-secondary">
              Планировки
            </div>
            <Slider images={villaPlans.villa3} />
            <VillaDescription items={villaDescriptions.villa3} />
          </div>

          <div className="ramadan_villa-container">
            <div className="ramadan_description-title">Вилла №4</div>
            <Slider images={villaImages.villa4} />
            <div className="ramadan_description-title-secondary">
              Планировки
            </div>
            <Slider images={villaPlans.villa4} />
            <VillaDescription items={villaDescriptions.villa4} />
          </div>

          <div className="ramadan_villa-container">
            <div className="ramadan_description-title">Вилла №5</div>
            <Slider images={villaImages.villa5} />
            <div className="ramadan_description-title-secondary">
              Планировки
            </div>
            <Slider images={villaPlans.villa5} />
            <VillaDescription items={villaDescriptions.villa5} />
          </div>
        </div>
        <div className="ramadan_price-container">
          <h2 className="ramadan_description-title">Условия покупки</h2>
          <div className="ramadan_price-full">
            <span>Полная оплата*</span>
            <strong>12 000 000 ₽</strong>
          </div>

          <div className="ramadan_price-section-title">Условия рассрочки</div>

          <div className="ramadan_price-grid">
            <div className="ramadan_price-item">
              <div>12 месяцев</div>
              <div>
                наценка <strong>0%</strong>
              </div>
              <div>
                в месяц <strong>1 000 000 ₽</strong>
              </div>
            </div>
            <div className="ramadan_price-item">
              <div>24 месяца</div>
              <div>
                наценка <strong>15%</strong>
              </div>
              <div>
                в месяц <strong>575 000 ₽</strong>
              </div>
            </div>
            <div className="ramadan_price-item">
              <div>36 месяцев</div>
              <div>
                наценка <strong>25%</strong>
              </div>
              <div>
                в месяц <strong>417 000 ₽</strong>
              </div>
            </div>
            <div className="ramadan_price-item">
              <div>48 месяцев</div>
              <div>
                наценка <strong>30%</strong>
              </div>
              <div>
                в месяц <strong>325 000 ₽</strong>
              </div>
            </div>
          </div>

          <div className="ramadan_price-section-title">Рассрочка 50/50</div>

          <div className="ramadan_price-split">
            <div className="ramadan_price-split-item">
              <div>до сдачи</div>
              <strong>6 000 000 ₽</strong>
            </div>
            <div className="ramadan_price-split-item">
              <div>после сдачи</div>
              <strong>6 000 000 ₽</strong>
            </div>
          </div>

          <div className="ramadan_price-note">*цена виллы</div>
          <TelegramForm landing="Поселок Рамадан" />
        </div>
      </div>
    </>
  );
};
